import "./ContactDetails.css";

function ContactDetails({
  company,
  addressLines,
  phone,
  mobile,
  fax,
  email,
  note,
}) {
  return (
    <section className="contact-details-container">
      <div className="contact-details-panel hover-lift">
        <h2>Direkter Kontakt</h2>

        {company && <p className="contact-details-company">{company}</p>}

        {addressLines && addressLines.length > 0 && (
          <p className="contact-details-block">
            {addressLines.map((line) => (
              <span key={line}>
                {line}
                <br />
              </span>
            ))}
          </p>
        )}

        <div className="contact-details-block">
          {phone && (
            <p>
              Telefon:{" "}
              <a href={`tel:${phone.replace(/\s+/g, "")}`}>{phone}</a>
            </p>
          )}
          {fax && <p>Fax: {fax}</p>}
          {email && (
            <p>
              E-Mail: <a href={`mailto:${email}`}>{email}</a>
            </p>
          )}
        </div>

        {note && <p className="contact-details-note">{note}</p>}
      </div>
    </section>
  );
}

export default ContactDetails;
